import AnimationContainer from "components/animation-container";
import ClassifiedText from "components/classified-text";
import RevealContent from "components/reveal-content";
import { StaticQuery, graphql } from "gatsby";
import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import handleViewport from "react-in-viewport";
import TabsPart from "sections/about/parts/TabsPart";
import styled, { css, keyframes } from "styled-components";
import Typewriter from "typewriter-effect";
import Eyes from "../../components/eyes/eyes";

class Viewport_Typewriter extends React.Component {
  state = { started: false };

  componentDidMount() {
    this._isMounted = true;

    // If force is set, start immediately (e.g. access-granted message)
    if (this.props.force) return;

    if (typeof window !== 'undefined' && window.__pageRevealed) {
      if (this.props.inViewport && !this.state.started) {
        setTimeout(() => {
          if (this._isMounted) this.setState({ started: true });
        }, 50);
      }
      return;
    }

    this._onPageRevealed = () => {
      if (this.props.inViewport && !this.state.started) {
        setTimeout(() => {
          if (this._isMounted) this.setState({ started: true });
        }, 50);
      }
    };
    if (typeof window !== 'undefined') {
      window.addEventListener('pageRevealed', this._onPageRevealed);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
    if (this._onPageRevealed && typeof window !== 'undefined') {
      window.removeEventListener('pageRevealed', this._onPageRevealed);
    }
  }

  componentDidUpdate() {
    const pageReady = this.props.force || (typeof window !== 'undefined' && window.__pageRevealed);
    if (pageReady && this.props.inViewport && !this.state.started) {
      this.setState({ started: true });
    }
  }

  render() {
    const refProp = this.props.innerRef || this.props.forwardedRef || null;
    return (
      <span ref={refProp} style={{ width: '100%' }}>
        {(this.state.started || this.props.force) ? (
          <Typewriter
            key={this.props.keyStr}
            options={{ delay: 20, cursor: '_' }}
            onInit={(typewriter) => {
              typewriter.typeString(this.props.text).start();
            }}
          />
        ) : (
            <span style={{opacity: 0}}>{this.props.text}</span>
        )}
      </span>
    );
  }
}

const ViewportTypewriter = typeof handleViewport === 'function' 
  ? handleViewport(Viewport_Typewriter) 
  : Viewport_Typewriter;

const Section = styled.section`
  z-index: 300;
  /* position: relative; */
  overflow: hidden;
  padding-top: 100px;
  padding-bottom: 100px;
  .particles {
    position: absolute;
    width: 100%;
    height: 100%;
  }
  @media (max-width: 767px) {
    padding: 80px 20px;
  }
  @media (max-width: 500px) {
    padding: 0 20px;
  }
`;

const AboutContainer = styled(Container)`
  padding-top: 50px;
  padding-bottom: 50px;
  /* @media (max-width: 500px) {
    padding: 50px 0;
  } */
`;

const LeftCol = styled(Col)`
  display: flex;
  align-items: baseline;
  justify-content: center;
  @media (max-width: 500px) {
    margin-bottom: 50px;
  }
`;

const AnimatedShadow = keyframes`
        0%   {box-shadow: 0 28px 60px rgba(4, 229, 229, .5);}
        10%  {box-shadow: 0 28px 60px rgba(243, 112, 85, .5);}
        20%  {box-shadow: 0 28px 60px rgba(239, 78, 123, .5);}
        30%  {box-shadow: 0 28px 60px rgba(161, 102, 171, .5);}
        40% {box-shadow: 0 28px 60px rgba(80, 115, 184, .5);}
        50% {box-shadow: 0 28px 60px rgba(4, 229, 229, .5);}
        60% {box-shadow: 0 28px 60px rgba(7, 179, 155, .5);}
        70% {box-shadow: 0 28px 60px rgba(111, 186, 130, .5);}
        80% {box-shadow: 0 28px 60px rgba(80, 115, 184, .5);}
        90% {box-shadow: 0 28px 60px rgba(16, 152, 173, .5);}
        100% {box-shadow: 0 28px 60px rgba(243, 112, 85, .5);}
    `;
const ImageContainer = styled.div`
  position: relative;
  border-radius: 20px;
  overflow: hidden;
  animation: ${AnimatedShadow} 10s infinite alternate;
  @media (max-width: 767px) {
    margin-bottom: 50px;
  }
`;

const Image = styled.img`
  cursor: pointer;
  max-width: 400px;
  @media (max-width: 767px) {
    max-width: 200px;
  }
  @media (max-width: 1400px) {
    max-width: 280px;
  }
`;

const Separator = styled.div`
  height: 5px;
  width: 50px;
  background-color: #04e5e5;
  margin-bottom: 20px;
`;

const Heading = styled.h2`
  font-size: 70px;
  font-family: Teko;
  color: #fff;
  line-height: 50px;
`;

const Text = styled.p`
  font-size: 12px;
  font-weight: 300;
  color: #c5c5c5;
`;

const FontColor = keyframes`
        0%   {color:  rgba(4, 229, 229, .5);}
        10%  {color:  rgba(243, 112, 85, .5);}
        20%  {color:  rgba(239, 78, 123, .5);}
        30%  {color:  rgba(161, 102, 171, .5);}
        40% {color:  rgba(80, 115, 184, .5);}
        50% {color:  rgba(4, 229, 229, .5);}
        60% {color:  rgba(7, 179, 155, .5);}
        70% {color:  rgba(111, 186, 130, .5);}
        80% {color:  rgba(80, 115, 184, .5);}
        90% {color:  rgba(16, 152, 173, .5);}
        100% {color:  rgba(243, 112, 85, .5);}
        `;
const EyeText = styled.p`
  font-size: 12px;
  font-weight: bold;
  animation: ${FontColor} 10s infinite alternate;
`;

const AlertPulse = keyframes`
  0% {
    box-shadow: inset 3px 0 0 0 #04e5e5, 0 0 0 0 rgba(4, 229, 229, 0);
  }
  50% {
    box-shadow: inset 3px 0 0 0 #04e5e5, -4px 0 15px 0 rgba(4, 229, 229, 0.6);
  }
  100% {
    box-shadow: inset 3px 0 0 0 #04e5e5, 0 0 0 0 rgba(4, 229, 229, 0);
  }
`;

const SystemAlertText = styled.div`
  color: #fff;
  font-family: 'Courier New', Courier, monospace;
  font-size: 14px;
  line-height: 1.4;
  letter-spacing: 0.5px;
  margin-bottom: 20px;
  opacity: 1;
  display: flex;
  align-items: flex-start;
  background-color: rgba(4, 229, 229, 0.05); /* Solid stable deep cyan tint */
  padding: 10px 15px;
  min-height: 60px;
  
  @media (max-width: 767px) {
    font-size: 11px;
    padding: 8px 10px;
    min-height: 65px;
  }
  
  border-left: 3px solid ${props => props.$isAllDecrypted ? '#04e5e5' : 'transparent'};
  ${props => !props.$isAllDecrypted && css`
    animation: ${AlertPulse} 2.5s infinite ease-in-out;
  `}
  border-radius: 0 4px 4px 0;
  
  &::before {
    content: '[ SYS INFO ]';
    font-weight: bold;
    margin-right: 10px;
    white-space: nowrap;
    flex-shrink: 0;
  }
`;

class AboutPersonal extends React.Component {
  state = {
    imgClickable: false,
    imgHeight: 0,
    imgWidth: 0,
    eyesDisable: true,
    decryptedCount: 0,
  };

  currentDecryptedCount = 0;

  handleDecrypt = () => {
    this.currentDecryptedCount += 1;
    // Only trigger a massive React DOM re-render when the final objective is met (10/10)
    if (this.currentDecryptedCount === 10) {
      this.setState({
        decryptedCount: 10,
      });
    }
  };



  animationFinished = () => {
    this.setState({ imgClickable: true });
  };

  updateEasterEggAreaSize = () => {
    if (
      this.state.imgHeight !== this.imgEl.offsetHeight ||
      this.state.imgWidth !== this.imgEl.offsetWidth
    ) {
      this.setState({
        imgHeight: this.imgEl.offsetHeight,
        imgWidth: this.imgEl.offsetWidth,
      });
    }
  };

  toggleEyes = () => {
    this.updateEasterEggAreaSize();
    this.setState((prevState) => ({
      eyesDisable: !prevState.eyesDisable,
    }));
  };

  showMyWords = () => {};

  render() {

    let eyes = null;
    if (!this.state.eyesDisable) {
      eyes = (
        <Eyes imgHeight={this.state.imgHeight} imgWidth={this.state.imgWidth} />
      );
    }

    return (
      <Section id="about" onMouseEnter={this.showMyWords}>
        <AboutContainer>
          <Row>
            <LeftCol md={6}>
              <AnimationContainer animation="fadeIn">
                <ImageContainer onClick={this.toggleEyes}>
                  <RevealContent
                    delay={500}
                    callbackFunc={this.animationFinished}
                  >
                    <Image
                      ref={(image) => {
                        this.imgEl = image;
                      }}
                      onLoad={() => {
                        this.updateEasterEggAreaSize();
                      }}
                      src={this.props.image.childImageSharp.fluid.src}
                      alt="about"
                    />
                  </RevealContent>
                  {eyes}
                </ImageContainer>
              </AnimationContainer>
            </LeftCol>
            <Col md={6}>
              <AnimationContainer animation="fadeIn">
                <Heading>About Me</Heading>
                <Separator />
                <SystemAlertText $isAllDecrypted={this.state.decryptedCount >= 10}>
                  <ViewportTypewriter
                    keyStr={this.state.decryptedCount >= 10 ? 'granted' : 'detecting'}
                    force={this.state.decryptedCount >= 10}
                    text={this.state.decryptedCount >= 10 
                          ? "All classified data successfully decrypted. Access granted." 
                          : "Classified data detected. Hover or tap redacted blocks to decrypt."}
                  />
                </SystemAlertText>
                <Text>
                  I am a <ClassifiedText onReveal={this.handleDecrypt}>full-stack software engineer</ClassifiedText> who bridges the gap between <ClassifiedText onReveal={this.handleDecrypt}>modern web development</ClassifiedText>, proactive cybersecurity, and AI-empowered engineering. My foundation lies in <ClassifiedText onReveal={this.handleDecrypt}>architecting scalable applications</ClassifiedText> using React, Next.js, Angular, and the Node.js ecosystem.
                  <br /><br />
                  What sets my approach apart is a deep understanding of offensive and defensive <ClassifiedText onReveal={this.handleDecrypt}>security primitives</ClassifiedText>. From hands-on <ClassifiedText onReveal={this.handleDecrypt}>penetration testing</ClassifiedText> and vulnerability assessments to proactive <ClassifiedText onReveal={this.handleDecrypt}>threat mitigation</ClassifiedText>, I build systems that are as resilient as they are functional. Furthermore, I actively engineer <ClassifiedText onReveal={this.handleDecrypt}>autonomous AI agents</ClassifiedText> and integrate the <ClassifiedText onReveal={this.handleDecrypt}>Model Context Protocol</ClassifiedText> (MCP) into my workflows. By treating advanced LLMs as a powerful multiplier to <ClassifiedText onReveal={this.handleDecrypt}>construct custom tools</ClassifiedText> and <ClassifiedText onReveal={this.handleDecrypt}>automate complex tasks</ClassifiedText>, I deliver highly performant, secure, and forward-thinking technological solutions.
                </Text>
                <EyeText>
                  {`<== `}Psst! Click my photo to activate "Stalker Mode" and watch my eyes follow your cursor! 👀
                </EyeText>
                <TabsPart />
              </AnimationContainer>
            </Col>
          </Row>
        </AboutContainer>
        {/* <CounterRow>
          <Container>
            <Row>
              <Col md={3}>
                <AnimationContainer animation="fadeIn" delay={1000}>
                  <CounterComponent>
                    <Counter value={5} duration={5} delay={1000} symbol="+" text="5 Years of Experience" animation={true} />
                  </CounterComponent>
                </AnimationContainer>
              </Col>
              <Col md={3}>
                <AnimationContainer animation="fadeIn" delay={1000}>
                  <CounterComponent>
                    <Counter value={100} duration={5} delay={1000} symbol="+" text="Clients Worked With" animation={true} />
                  </CounterComponent>
                </AnimationContainer>
              </Col>
              <Col md={3}>
                <AnimationContainer animation="fadeIn" delay={1000}>
                  <CounterComponent>
                    <Counter value={5} duration={5} delay={1000} text="Certifications" animation={true} />
                  </CounterComponent>
                </AnimationContainer>
              </Col>
              <Col md={3}>
                <AnimationContainer animation="fadeIn" delay={1000}>
                  <CounterComponent>
                    <Counter value={10} duration={5} delay={1000} symbol="+" text="Honourable Awards" animation={true} />
                  </CounterComponent>
                </AnimationContainer>
              </Col>
            </Row>
          </Container>
        </CounterRow> */}
      </Section>
    );
  }
}

export default (props) => (
  <StaticQuery
    query={graphql`
      query {
        image: file(relativePath: { eq: "about-me.jpg" }) {
          childImageSharp {
            fluid(maxHeight: 2000) {
              src
            }
          }
        }
      }
    `}
    render={(data) => {
      if (!data || !data.image) return null;
      return <AboutPersonal image={data.image} {...props} />;
    }}
  />
);
